export default {
  getHead: () => {
    return [{name: '사업장명'}, {name: '신고인'}, {name: '신고내용'}, {name: '신고일'}, {name: '처리내용'}, {name: '완료일'}, {name: '작성자'}, {name: '작성일'}]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).inputA_1
        case 1: return func.getContent(value).inputC_3
        case 2: return func.getContent(value).inputD_1
        case 3: return func.getContent(value).inputB_2
        case 4: return func.getContent(value).inputF_4
        case 5: return func.getContent(value).inputF_5
        case 6: return value.user ? value.user.name : value.author.name
        case 7: return func.getContent(value).inputA_4
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.inputA_4) {
      nav.dateTarget = 'content$body.inputA_4'
      nav.dateBegin = 'nav.value.inputA_4.sDate'
      nav.dateEnd = 'nav.value.inputA_4.eDate'
    }
    return {inputA_4: nav.value.inputA_4}
  },
  getSearchKeyword: (nav) => {
    return []
  },
}
